<!-- <app-welcome *ngIf="!welcome" ></app-welcome> -->
<app-header></app-header>
<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<router-outlet></router-outlet>
<app-dailyoffers></app-dailyoffers>
<app-footer></app-footer>
<button *ngIf="showInstallButton && isMobile" (click)="installPWA()" class="btn btn-primary">

  {{ "Add to Home Screen" | transloco }}
</button>
